import React, { FormEvent, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import emailjs from "@emailjs/browser";
import clsx from "clsx";

type SendStatus = "SUCCESS" | "ERROR" | "LOADING" | undefined;
type Tab = "CONTACT" | "PRESCRIPTION";

export function ContactForm2(): JSX.Element {
    const [sendStatus, setSendStatus] = useState<SendStatus>(undefined);
    const [activeTab, setActiveTab] = useState<Tab>("CONTACT");

    const form = useRef<HTMLFormElement>(null);

    const getTemplateId = (tab: Tab): string => {
        return tab === "PRESCRIPTION"
            ? "template_m5gkr7u"
            : "template_6vb5jsc";
    };

    const sendEmail = (e: FormEvent) => {
        e.preventDefault();
        if (!form.current) return;

        setSendStatus("LOADING");

        emailjs.sendForm(
            "service_ni39etl",
            getTemplateId(activeTab),
            form.current,
            "L0aSQRm57A9QBdQri"
        ).then(
            () => {
                form.current?.reset();
                setSendStatus("SUCCESS");
            },
            () => {
                setSendStatus("ERROR");
            }
        );
    };

    return (
        <form ref={form} onSubmit={sendEmail}>
            {/* Tabs */}
            <div className="tabs tabs-boxed mb-6 max-w-md">
                <button
                    type="button"
                    className={clsx("tab flex-1 text-center whitespace-nowrap font-semibold", { "tab-active": activeTab === "CONTACT" })}
                    onClick={() => setActiveTab("CONTACT")}
                >
                    Schreiben Sie uns
                </button>
                <button
                    type="button"
                    className={clsx("tab flex-1 text-center whitespace-nowrap font-semibold", { "tab-active": activeTab === "PRESCRIPTION" })}
                    onClick={() => setActiveTab("PRESCRIPTION")}
                >
                    Rezeptwunsch
                </button>
            </div>

            {/* Name */}
            <div className="form-control w-full max-w-md">
                <label className="label">
                    <span className="label-text">Name</span>
                </label>
                <input
                    type="text"
                    className="input input-bordered w-full"
                    name="user_name"
                    required
                />
            </div>

            {/* E-Mail oder Geburtsdatum */}
            {activeTab === "CONTACT" ? (
                <div className="form-control w-full max-w-md">
                    <label className="label">
                        <span className="label-text">E-Mail Adresse</span>
                    </label>
                    <input
                        type="email"
                        className="input input-bordered w-full"
                        name="user_email"
                        required
                    />
                </div>
            ) : (
                <div className="form-control w-full max-w-md">
                    <label className="label">
                        <span className="label-text">Geburtsdatum</span>
                    </label>
                    <input
                        type="date"
                        className="input input-bordered w-full"
                        name="birth_date"
                        required
                    />
                </div>
            )}

            {/* Nachricht / Rezeptwunsch */}
            <div className="form-control w-full max-w-md">
                <label className="label">
                    <span className="label-text">
                        {activeTab === "CONTACT" ? "Nachricht" : "Rezeptwunsch"}
                    </span>
                </label>
                <textarea
                    className="textarea textarea-bordered h-24 w-full"
                    name={activeTab === "CONTACT" ? "message" : "prescription"}
                    required
                />
            </div>

            {/* Submit */}
            <button
                type="submit"
                className={clsx(
                    "btn btn-accent text-neutral w-full max-w-md mt-4",
                    { loading: sendStatus === "LOADING" }
                )}
                disabled={sendStatus === "LOADING"}
            >
                {sendStatus !== "LOADING" && "Senden"}
            </button>

            {/* Success */}
            {sendStatus === "SUCCESS" && (
                <div className="alert alert-success shadow-lg mt-4 w-full max-w-md flex-row">
                    <div>
                        <span>Die Nachricht wurde verschickt!</span>
                    </div>
                    <button
                        type="button"
                        className="btn btn-sm bg-transparent border-none"
                        onClick={() => setSendStatus(undefined)}
                    >
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>
            )}

            {/* Error */}
            {sendStatus === "ERROR" && (
                <div className="alert alert-error shadow-lg mt-4 w-full max-w-md flex-row">
                    <div>
                        <span>Fehler beim Senden der Nachricht.</span>
                    </div>
                    <button
                        type="button"
                        className="btn btn-sm bg-transparent border-none"
                        onClick={() => setSendStatus(undefined)}
                    >
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>
            )}
        </form>
    );
}
